





































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KReadOnly } from '@kasasa/fbase-components';
import Location from '@/services/Location';

@Component({
	components: {
		KReadOnly,
	},
}) 
export default class LocationHeaderRO extends Vue {
	@Prop({ default: false }) readonly location!: Location;

	get locActive() {
		return this.location.enabled ? 'Active' : 'Inactive';
	}

	get locType() {
		return this.location.isBrick ? ( this.location.hasAtm ? 'Branch & ATM' : 'Branch' ) : ( this.location.hasAtm ? 'ATM' : 'No Services');
	}
}
